import { connect } from "react-redux";

import OrderConfirmation from "./orderConfirmation";
import { getFeatureFlagsData } from '../featureFlags/store/selectors';
import {
  getOrderConfirmationStatus,
  getOrderConfirmationData,
  getSentOrderConfirmationStatus,
  getOrderNumber,
} from "./store/selectors";
import { getCartData, getCheckboxSettingsData, getDiscountSelectionSectionSettingsData, getPromotionsData, getPromotionsStatus } from "../orderBuilder/store/selectors";
import { getProfileData } from "../login/store/selectors";
import {
  addOrderToCart,
  loadCheckboxSettings,
  loadDiscountSelectionSectionSettings,
  loadPromotions,
} from "../orderBuilder/store/action-creators";
import {
  submitOrder,
  loadOrderConfirmation,
  resetOrderNumber,
} from "./store/action-creators";
import { getIsStockOrder } from "../storeHome/store/selectors";
import { setIsStockOrder } from "../storeHome/store/action-creators";

const mapStateToProps = (state) => ({
  featureFlags: getFeatureFlagsData(state),
  orderConfirmationStatus: getOrderConfirmationStatus(state),
  orderConfirmationData: getOrderConfirmationData(state),
  sentOrderConfirmationStatus: getSentOrderConfirmationStatus(state),
  orderNumber: getOrderNumber(state),
  cartData: getCartData(state),
  profileData: getProfileData(state),
  isStockOrder: getIsStockOrder(state),
  checkboxSettingsData: getCheckboxSettingsData(state),
  discountSelectionSectionSettingsData: getDiscountSelectionSectionSettingsData(state),
  promotionsData: getPromotionsData(state),
  promotionsStatus: getPromotionsStatus(state),
});

const mapDispatchToProps = {
  submitOrder,
  addOrderToCart,
  loadOrderConfirmation,
  loadCheckboxSettings,
  loadDiscountSelectionSectionSettings,
  loadPromotions,
  resetOrderNumber,
  setIsStockOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderConfirmation);
